export default __webpack_public_path__ + "static/media/zee_mask_banner.0a21ddd5.png";